<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="row">
            <div class="col-lg-12 col-sm-12 mb-3">
                <div class="card p-4">
                    <div class="media">
                        <div class="avatar-sm mr-3">
                            <span class="avatar-title rounded-circle bg-light text-primary border-primary font-size-22">
                                <i class="bx bx-world bx-md"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <h5 class="mt-3">{{ $t('website.website-location-search') }}</h5>
                        </div>
                    </div>
                    <div class="row mt-5 mb-3">
                        <div class="col-sm-12 text-right">
                            <div class="input-group">
                                <input
                                id="search"
                                type="text"
                                class="form-control"
                                v-model="searchKey"
                                v-on:input="removeHttp(searchKey)"
                                placeholder="domainname.com"
                                aria-describedby="search"
                                @keyup.enter="searchWebsite"
                                />
                                <div class="input-group-prepend">
                                <button
                                    id="search"
                                    class="input-group-text bg-primary text-white"
                                    @click="searchWebsite"
                                >
                                <i class="bx bx-search-alt search-icon"></i>
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>

                      <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                              <div class="spinner-border text-secondary" role="status" v-if="loading">
                            <span class="sr-only"><p>{{ $t('website.website-location') }}</p></span>
                          </div>
                        </div>
                    </div>
                      <div v-if="error !== '' && !loading" class="row mt-5 mb-5 pb-4  mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{error}}</span>  
                        </div>
                    </div>
                    
                      <div v-if="!SearchResult.ip && !loading && search && error == ''" class="row mt-5 mb-5 pb-4 mx-auto">
                        <div class="text-center">
                           <span class="text-secondary">{{ $t('all.dnf') }}</span>  
                        </div>
                    </div>
                    <div>
                        <div class="row mt-0" v-if="SearchResult">
                          <!-- <p v-if="loading">
                            Loading ..
                          </p> -->
                          <div class="col-sm-6">
                              <div class="py-3 px-3">
                                <!-- <p v-if="SearchResult.ip"> Find Website / IP Location </p> -->
                                <p v-if="SearchResult.ip">  <b>{{ $t('website.ip') }} :</b> {{SearchResult.ip}} </p>
                                <p v-if="SearchResult.version">  <b>{{ $t('website.version') }} :</b> {{SearchResult.version}} </p>
                                <p v-if="SearchResult.city">  <b>{{ $t('website.city') }}:</b> {{SearchResult.city}} </p>
                                <p  v-if="SearchResult.region">  <b>{{ $t('website.region') }}:</b> {{SearchResult.region}} </p>
                                <p  v-if="SearchResult.region_code">  <b>{{ $t('website.region_code') }}:</b> {{SearchResult.region_code}}  </p>
                                <p  v-if="SearchResult.icountryp">  <b>{{ $t('website.country') }}:</b> {{SearchResult.country}} </p>
                                <p  v-if="SearchResult.country_name">  <b>{{ $t('website.country_name') }}:</b> {{SearchResult.country_name}} </p>
                                <p  v-if="SearchResult.country_code">  <b>{{ $t('website.country_code') }}:</b>  {{SearchResult.country_code}} </p>
                                <p  v-if="SearchResult.country_code_iso3">  <b>{{ $t('website.country_code_iso3') }}:</b> {{SearchResult.country_code_iso3}} </p>
                                <p  v-if="SearchResult.country_capital">  <b>{{ $t('website.country_capital') }}y:</b> {{SearchResult.country_capital}} </p>
                                <p  v-if="SearchResult.country_tld">  <b>{{ $t('website.country_tld') }}e:</b> {{SearchResult.country_tld}} </p>
                                <p  v-if="SearchResult.continent_code">  <b>{{ $t('website.continent_code') }}:</b> {{SearchResult.continent_code}} </p>
                                <p  v-if="SearchResult.in_eu">  <b>{{ $t('website.in_eu') }}:</b> {{SearchResult.in_eu}}</p>
                                <p  v-if="SearchResult.postal">  <b>{{ $t('website.postal') }}:</b>  {{SearchResult.postal}} </p>
                                <!-- <p  v-if="SearchResult.latitude">  <b>{{ $t('website.latitude') }}:</b>  {{SearchResult.latitude}} </p>
                                <p  v-if="SearchResult.longitude">  <b>{{ $t('website.longitude') }}:</b>  {{SearchResult.longitude}} </p> -->
                                <!-- <p  v-if="SearchResult.timezone">  <b>{{ $t('website.timezone') }}:</b> {{SearchResult.timezone}} </p> -->
                                <p  v-if="SearchResult.utc_offset">  <b>{{ $t('website.utc_offset') }}:</b>  {{SearchResult.utc_offset}} </p>
                                <p  v-if="SearchResult.country_calling_code">  <b>{{ $t('website.country_calling_code') }}:</b>  {{SearchResult.country_calling_code}} </p>
                                <p  v-if="SearchResult.currency">  <b>{{ $t('website.currency') }}s </b>, {{SearchResult.currency}}n </p>
                                <p  v-if="SearchResult.currency_name">  <b>{{ $t('website.currency_name') }}:</b> {{SearchResult.currency_name}} </p>
                                <p  v-if="SearchResult.languages">  <b>{{ $t('website.languages') }}:</b> {{SearchResult.languages}}</p>
                                <p  v-if="SearchResult.country_area">  <b>{{ $t('website.country_area') }}:</b>  {{SearchResult.country_area}} </p>
                                <p  v-if="SearchResult.asn">  <b>{{ $t('website.asn') }}:</b> {{SearchResult.asn}} </p>
                                <p  v-if="SearchResult.org">  <b>{{ $t('website.org') }}:</b> {{SearchResult.org}} </p>
                            </div>
                               <div class="col-sm-12 text-left" v-if="SearchResult.ip">
                                  <b-button class="btn" variant="secondary" size="sm" @click="clearData"><i class="fa fa-times"></i> {{ $t('website.clear') }}</b-button> <b-button class="btn" variant="success" size="sm" @click="saveWebsiteInfoLocation"><i class="fa fa-check"></i> {{ $t('website.save') }}</b-button>
                              </div> 
                          </div>
                          <div class="col-sm-6">
                                <div class="card" v-if="SearchResult.latitude">
                                    <gmap-map ref="mymap" :center="{ lat: parseFloat(SearchResult.latitude), lng: parseFloat(SearchResult.longitude) }" :zoom="4" style="height: 40vh">
                                        <gmap-marker
                                        :position="google && new google.maps.LatLng(SearchResult.latitude, SearchResult.longitude)"
                                        ></gmap-marker>
                                    </gmap-map>
                                </div>
                                 <div class="card border pt-2 mt-3" v-if="SearchResult.latitude">
                                   <h5 class="px-3 py-1">{{ $t('website.geo') }}</h5>
                                  <table class="table">
                                      <tr>
                                        <th width="25%" class="text-left">{{ $t('website.city') }}</th>
                                        <td>{{SearchResult.region}}</td>
                                      </tr>
                                        <tr>
                                        <th width="25%" class="text-left">{{ $t('website.country_name') }}</th>
                                        <td>{{SearchResult.country_name}} ({{SearchResult.country_code}})</td>
                                      </tr>
                                      <tr>
                                        <th width="25%" class="text-left">{{ $t('website.coordinates') }}</th>
                                        <td>{{SearchResult.latitude}},  {{SearchResult.longitude}}</td>
                                      </tr>
                                         <tr>
                                        <th width="25%" class="text-left">{{ $t('website.timezone') }}</th>
                                        <td>{{SearchResult.timezone}}</td>
                                      </tr>
                                  </table>
                                </div>
                          </div>
                        </div>
                       
                    </div>
                   </div>
            </div>
        </div>

         <div class="row mt-5">
          <div class="col-sm-6">
              <h5>{{ $t('website.list_web_location') }}</h5>
          </div>
          <div class="col-sm-6 text-right">
              <!-- <router-link to="/twitter-search"><b-button class="btn" variant="primary"><i class="bx bx-user-plus bx-xl"></i> Add</b-button></router-link> -->
          </div>
      </div>
      <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t('all.show') }}&nbsp;&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-0"></b-form-select>&nbsp;&nbsp; 
                  </label>{{ $t('all.entries') }} 
                    <b-button class="btn btn-sm ml-3" variant="danger" @click="bulkAction()" v-if="selected[0]"> {{ $t('button.bulk') }}  : {{selected.length}}  {{ $t('button.row-data') }} </b-button>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    {{ $t('all.search') }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
                <b-table
                  :items="tableData"
                  :fields="fields"
                  striped bordered
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                >
                <template #head(bulk) width="4%">
                    <b-form-checkbox
                            v-model="selectAll" 
                            @change="select"
                            class="text-center mt-0">
                    </b-form-checkbox>
                </template>
                <template #cell(bulk)="row" width="4%">
                      <b-form-checkbox
                      class="text-center mt-0"
                        v-model="selected"
                        :value="row.item.id_ip"
                      >
                      </b-form-checkbox>
                </template>
                <template #cell(ip_address)="row">
                  <p>{{row.item.ip_address}}</p>
                  </template>
                  <template #cell(actions)="row">
                      <router-link :to="{ name: 'find-website-detail', params: { id: row.item.id_ip }}"><b-button class="mr-1 btn-sm mb-1" variant="secondary" >
                      <i class="bx bx-show-alt"></i> 
                      </b-button></router-link>
                        <b-button class="btn-sm mb-1" variant="danger" @click="deleteWebsiteInfoLocation(row.item.id_ip)">
                      <i class="bx bx-trash"></i>
                      </b-button>
                  </template>
                </b-table>
              
                <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                    <div class="text-center">
                          <div class="spinner-border text-secondary" role="status" v-if="loadingInfo">
                        <span class="sr-only"><p>{{ $t('website.website-info') }}</p></span>
                      </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="rows > 10">
                  <div class="col-2 col-xl-1">
                      <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                      </div> -->
                      <label class="d-inline-flex align-items-center">
                      Page
                      <b-form-input
                          v-model="currentPage"
                          placeholder="Page"
                          class="form-control w-10 form-control ml-2"
                      ></b-form-input>
                      </label>
                  </div>
                  <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                      </ul>
                  </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from 'moment';
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import {gmapApi} from 'vue2-google-maps';
import Swal from "sweetalert2";

export default {
    page: {
        title: "Tools Website",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
        return {
            urlimage: 'http://localhost:8001/api/target/image-project?name=',
            loading: false,
            error:'',
            search: false,
            loadingInfo: false,
            searchKey: "",
            SearchResult: [],
            total_results:"",
            tableData:[],
            selected:[],
            selectAll: false,
            dnf:false,
            dnfp:false,
            is_spam:"",
            search:false,
            title: this.$t('website.website-location'),
            items: [
                {
                text: "Dashboard",
                href: "/"
                },
                {
                text: this.$t('website.website-location'),
                active: true
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "age",
            sortDesc: false,
            fields: [
                 { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
                { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
                { key: "ip_address", label: this.$t('website.ip_address')},
                { key: "domain_name", label: this.$t('website.domain_name'), sortable: true},
                { key: "version", label: this.$t('website.version')},
                { key: "region", label: this.$t('website.region'), sortable: true},
                { key: "country_name", label: this.$t('website.country_name'), sortable: true},
                { key: "org", sortable: true},
                { key: 'actions', class: 'text-center',   thStyle: { width: "12%" }, label: this.$t('website.actions') }
            ]
        }
    },
    computed: {
        google: gmapApi,
        rows() {
            return this.tableData.length;
        },
  },
    watch: { 
        address: {
            handler: function(n, o) {
                console.log(JSON.stringify(n));
                this.count1 = n.count;
            },
            deep: true  
        }
    },
  methods:{
     select() {
            // console.log('selected');
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.tableData) {
                    this.selected.push(this.tableData[i].id_ip);
                }
            }
        },
        searchWebsite(){
          this.error = '';
          this.loading = true;
          this.search = true;
          this.SearchResult = []
          const data = {
            "website": this.searchKey,
          }
          WebsiteService.searchDomainLocation(data)
          .then(response => {
                    this.SearchResult = response.data.output;
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    if( err.response.status == 500 ){
                      this.error = this.$t('all.error-500');
                    } else if( err.response.status == 404 ){
                      this.error = this.$t('all.error-404');
                    }
            });
        },
        saveWebsiteInfoLocation(){
          this.loadingsave = true;
          var data = {
             "domain_name" : this.searchKey,
             "ip_address" : this.SearchResult.ip,
              "version" : this.SearchResult.version,
              "city" : this.SearchResult.city,
              "region" : this.SearchResult.region,
              "region_code" : this.SearchResult.region_code,
              "country" : this.SearchResult.country,
              "country_name" : this.SearchResult.country_name,
              "country_code" : this.SearchResult.country_code,
              "country_code_iso3" : this.SearchResult.country_code_iso3,
              "country_capital" : this.SearchResult.country_code_iso3,
              "country_tld" : this.SearchResult.country_tld,
              "continent_code" : this.SearchResult.continent_code,
              "in_ue" : this.SearchResult.in_eu,
              "postal_code" : this.SearchResult.postal,
              "latitude" : this.SearchResult.latitude,
              "longitude" : this.SearchResult.longitude,
              "timezone" : this.SearchResult.timezone,
              "utc_offset" : this.SearchResult.ip,
              "country_calling_code" : this.SearchResult.ip,
              "currency" : this.SearchResult.currency,
              "currency_name" : this.SearchResult.currency_name,
              "languages" : this.SearchResult.languages,
              "country_area" : this.SearchResult.country_area,
              "country_population" : this.SearchResult.country_population,
              "asn" : this.SearchResult.asn,
              "org" : this.SearchResult.org
          }
          
          // console.log(data);
          WebsiteService.createWebInfoLocation(data)
          .then(response => {
                    // this.SearchResult = response.data.output;
                    this.searchKey = "";
                    this.SearchResult = "";
                    this.loading = false;
                    Swal.fire(response.data.message, '', 'success') 
                    this.getWebsiteInfoLocationUpdate();
                    this.clearData;
                    this.search = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    this.search = false;
            });
        },

        getWebsiteInfoLocation(){
          this.loadingInfo = true;
          WebsiteService.getWebInfoLocation()
          .then(response => {
                let val_data = response.data.data;
                val_data.forEach((val, index) => {
                let data = {
                    "no" : index+1,
                    "id_ip": val.id_ip, 
                    "domain_name": val.domain_name, 
                    "ip_address": val.ip_address, 
                    "version": val.version, 
                    "city": val.city, 
                    "region": val.region, 
                    "region_code": val.region_code, 
                    "country": val.country, 
                    "country_name": val.country_name, 
                    "country_code": val.country_code, 
                    "country_code_iso3": val.country_code_iso3, 
                    "country_capital": val.country_capital, 
                    "country_tld": val.country_tld, 
                    "continent_code": val.continent_code, 
                    "in_ue": val.in_ue, 
                    "postal_code": val.postal_code, 
                    "latitude": val.latitude, 
                    "longitude": val.longitude, 
                    "timezone": val.timezone, 
                    "utc_offset": val.utc_offset, 
                    "country_calling_code": val.country_calling_code, 
                    "currency": val.currency, 
                    "currency_name": val.currency_name, 
                    "languages": val.languages, 
                    "country_area": val.country_area, 
                    "country_population": val.country_population, 
                    "asn": val.asn, 
                    "org": val.org,
                    "created_at": val.created_at, 
                    "updated_at": val.updated_at
                }  
                this.tableData.push(data);
                });
                this.loadingInfo = false;
                this.total_results = response.data.data.length;
                })
                .catch(err => {
                  console.log(err);
                  this.loadingInfo = false;
            });
        },

          getWebsiteInfoLocationUpdate(){
          WebsiteService.getWebInfoLocation()
          .then(response => {
                let val_data = response.data.data;
                val_data.forEach((val, index) => {
                let data = {
                    "no" : index+1,
                    "id_ip": val.id_ip, 
                    "domain_name": val.domain_name, 
                    "ip_address": val.ip_address, 
                    "version": val.version, 
                    "city": val.city, 
                    "region": val.region, 
                    "region_code": val.region_code, 
                    "country": val.country, 
                    "country_name": val.country_name, 
                    "country_code": val.country_code, 
                    "country_code_iso3": val.country_code_iso3, 
                    "country_capital": val.country_capital, 
                    "country_tld": val.country_tld, 
                    "continent_code": val.continent_code, 
                    "in_ue": val.in_ue, 
                    "postal_code": val.postal_code, 
                    "latitude": val.latitude, 
                    "longitude": val.longitude, 
                    "timezone": val.timezone, 
                    "utc_offset": val.utc_offset, 
                    "country_calling_code": val.country_calling_code, 
                    "currency": val.currency, 
                    "currency_name": val.currency_name, 
                    "languages": val.languages, 
                    "country_area": val.country_area, 
                    "country_population": val.country_population, 
                    "asn": val.asn, 
                    "org": val.org,
                    "created_at": val.created_at, 
                    "updated_at": val.updated_at
                }  
                this.tableData.push(data);
                });
                this.loadingInfo = false;
                this.total_results = response.data.data.length
                })
                .catch(err => {
                  console.log(err);
                  this.loadingInfo = false;
            });
        },
         deleteWebsiteInfoLocation(id){
           Swal.fire({
                  title: this.$t('button.delete.modal.confirmText[0]'),
                  text: this.$t('button.delete.modal.confirmText[1]'),
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#34c38f",
                  cancelButtonColor: "#f46a6a",
                  cancelButtonText: this.$t('button.cancel.text'),
                  confirmButtonText: this.$t('button.delete.text')
              }).then((result) => {
                  if (result.isConfirmed) {
                      WebsiteService.deleteWebInfoLocation(id)
                      .then( response => {
                          this.getWebsiteInfoLocation();
                          Swal.fire({
                              position: "top-end",
                              icon: "success",
                              title: "Data Deleted Success",
                              showConfirmButton: false,
                              timer: 1500
                          });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
              });
        },
        bulkAction(){
        Swal.fire({
            title: this.$t('button.delete.modal.confirmText[0]'),
            text: this.$t('button.delete.modal.confirmText[1]'),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            cancelButtonText: this.$t('button.cancel.text'),
            confirmButtonText: this.$t('button.delete.text')
        }).then((result) => {
            if (result.isConfirmed) {
              var data = this.selected;
                WebsiteService.websiteBulkWebLocation(data)
                .then( response => {
                    this.selected = [];
                    this.getWebsiteInfoLocation();
                    Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: this.$t('alert.alert-delete-web'),
                        showConfirmButton: false,
                        timer: 1500
                    });
                      })
                      .catch( err => {
                          console.log(err);
                      });
                  }
            });
        },
        clearData(){
          this.SearchResult = "";
          this.searchKey = "";
          this.search = false;
        },
      formatDate(value){
          return moment(value).format("dddd, YYYY-MM-DD hh:mm");
      },
      removeHttp(url){
          let x = url.replace(/(^\w+:|^)\/\//, '').replace("/", "").replace('www.', '');
          return this.searchKey = x;
      },
      geocodedAddress(){
      const geocoder = this.google && new google.maps.Geocoder();
      geocoder.geocode( { 'address' : this.address }, function( results, status ) {
          // if( status == google.maps.GeocoderStatus.OK ) {
              console.log('geocode->',results[0].geometry.location.lat());
              //In this case it creates a marker, but you can get the lat and lng from the location.LatLng
              // map.setCenter( results[0].geometry.location );
              // var marker = new google.maps.Marker( {
              //     map     : map,
              //     position: results[0].geometry.location
              // } );
          // } else {
          //     alert( 'Geocode was not successful for the following reason: ' + status );
          // }
      } );
  },
  },
    mounted(){
      this.getWebsiteInfoLocation();
        this.totalRows = this.items.length;  
        // this.listTwitter();]
         this.$watch(()=>this.openMap, () => {
            if (this.openMap == true) {
              var latlong = this.SearchResult.latitude+','+ this.SearchResult.longitude;
                console.log(latlong);
                this.geocodedAddress();
            }
        })
    }
};
</script>

<style scoped>
.loading{
    padding-top:20%;
    padding-bottom:20%;
}
</style>